/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Limits applied when creating or updating saved commodities.
 * @export
 * @interface ShipmentLimitsSavedCommodity
 */
export interface ShipmentLimitsSavedCommodity {
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsSavedCommodity
     */
    maxDescriptionLength: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsSavedCommodity
     */
    maxSkuIdentifierLength: number;
}

/**
 * Check if a given object implements the ShipmentLimitsSavedCommodity interface.
 */
export function instanceOfShipmentLimitsSavedCommodity(value: object): value is ShipmentLimitsSavedCommodity {
    if (!('maxDescriptionLength' in value) || value['maxDescriptionLength'] === undefined) return false;
    if (!('maxSkuIdentifierLength' in value) || value['maxSkuIdentifierLength'] === undefined) return false;
    return true;
}

export function ShipmentLimitsSavedCommodityFromJSON(json: any): ShipmentLimitsSavedCommodity {
    return ShipmentLimitsSavedCommodityFromJSONTyped(json, false);
}

export function ShipmentLimitsSavedCommodityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipmentLimitsSavedCommodity {
    if (json == null) {
        return json;
    }
    return {
        
        'maxDescriptionLength': json['maxDescriptionLength'],
        'maxSkuIdentifierLength': json['maxSkuIdentifierLength'],
    };
}

  export function ShipmentLimitsSavedCommodityToJSON(json: any): ShipmentLimitsSavedCommodity {
      return ShipmentLimitsSavedCommodityToJSONTyped(json, false);
  }

  export function ShipmentLimitsSavedCommodityToJSONTyped(value?: ShipmentLimitsSavedCommodity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maxDescriptionLength': value['maxDescriptionLength'],
        'maxSkuIdentifierLength': value['maxSkuIdentifierLength'],
    };
}

